import 'core-js/modules/es.error.cause.js';
import 'core-js/modules/es.error.to-string.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.array.push.js';
import { jsx } from 'react/jsx-runtime';
import React, { useMemo, useContext, createContext } from 'react';
import classNames from 'classnames';
import { getThemeClassNames } from '@cognite/cogs-utils';
import { setupMuiLicense } from './_setup-mui-license/setup-mui-license.js';

setupMuiLicense();
var ConfigContext = /*#__PURE__*/createContext({});
var ConfigProvider = function ConfigProvider(_ref) {
  var children = _ref.children,
    getOverlayContainer = _ref.getOverlayContainer,
    dateFormat = _ref.dateFormat,
    timeFormat = _ref.timeFormat,
    _ref$shouldUseThinBor = _ref.shouldUseThinBorders,
    shouldUseThinBorders = _ref$shouldUseThinBor === undefined ? false : _ref$shouldUseThinBor,
    themeProps = _ref.themeProps,
    localizationProviderProps = _ref.localizationProviderProps,
    future = _ref.future;
  // will be used for initializing context later
  var contextValue = useMemo(function () {
    return {
      getOverlayContainer: getOverlayContainer,
      dateFormat: dateFormat,
      timeFormat: timeFormat,
      shouldUseThinBorders: shouldUseThinBorders,
      themeProps: themeProps,
      localizationProviderProps: localizationProviderProps,
      future: future
    };
  }, [getOverlayContainer, dateFormat, timeFormat, shouldUseThinBorders, themeProps, localizationProviderProps, future]);
  if (contextValue.shouldUseThinBorders) document.documentElement.style.setProperty('--cogs-border-width--emphasized', '1px');
  var classNamesToAdd = [];
  if (themeProps) {
    classNamesToAdd.push.apply(classNamesToAdd, getThemeClassNames(undefined, themeProps));
  }
  if (future === null || future === undefined ? undefined : future.v11_newColorTokens) {
    classNamesToAdd.push('cogs-v11-token-override');
  }
  if (classNamesToAdd.length > 0) {
    return jsx(ConfigContext.Provider, {
      value: contextValue,
      children: React.Children.map(children, function (child) {
        return /*#__PURE__*/React.cloneElement(child, {
          className: classNames.apply(undefined, [child.props.className].concat(classNamesToAdd))
        });
      })
    });
  }
  return jsx(ConfigContext.Provider, {
    value: contextValue,
    children: children
  });
};
var useConfigContext = function useConfigContext() {
  var configContext = useContext(ConfigContext);
  if (!configContext) {
    throw new Error('useConfigContext has to be used within <ConfigProvider>');
  }
  return configContext;
};
/**
 * In V10, `ConfigProvider` was not mentioned as a required component to use
 * Cogs. This hook is created to be used in only V10. In the new major version,
 * we should use `useConfigContext` and throw errors in relevant components if
 * `ConfigProvider` is not rendered.
 */
var useConfigContextLoose = function useConfigContextLoose() {
  var configContext = useContext(ConfigContext);
  return configContext !== null && configContext !== undefined ? configContext : {};
};

export { ConfigProvider, useConfigContext, useConfigContextLoose };
